import { render } from "./BlogView.vue?vue&type=template&id=4dc255c8&scoped=true"
import script from "./BlogView.vue?vue&type=script&lang=js"
export * from "./BlogView.vue?vue&type=script&lang=js"

import "./BlogView.vue?vue&type=style&index=0&id=4dc255c8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc255c8"]])

export default __exports__